import React, { Component } from 'react';

class ModalMensajeResultado extends Component {
    constructor(props) {
        super(props);
    }

    cerrarModal = () => {
        this.props.mostrarOcultarModal('modalMensajeResultado', false);
    }

    render() {
        const {
            mensaje
        } = this.props;

        return (
            <div className='modalContainer'>
                <div className='modalDemandaOutXS'>
                    <div className='modalConfirmarSalirTexto ABMModelos__modalResultadoReemplazarCuentasContables__textoResultado'>
                        {mensaje}
                    </div>
                    <div className='modalProcesosFooterShort'>
                        <button onClick={this.cerrarModal} className="btn btn-cta">Aceptar</button>
                    </div>
                </div>
            </div>

        )
    }
}

export default ModalMensajeResultado;
